import { lazy } from 'react';

export const PatientExercisesTableAsync = lazy(
 () => import('./PatientExercisesTable'),
);
export const PatientExercisesTableHistoryAsync = lazy(() => import('./patientExercisesTableHistory'));
